import { emptySplitApi as api } from "./empty";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getBalance: build.query<GetBalanceApiResponse, GetBalanceApiArg>({
      query: () => ({ url: `/balance` }),
    }),
    getBankAccounts: build.query<
      GetBankAccountsApiResponse,
      GetBankAccountsApiArg
    >({
      query: (queryArg) => ({
        url: `/bank-accounts`,
        params: {
          status: queryArg.status,
          page: queryArg.page,
          perpage: queryArg.perpage,
        },
      }),
    }),
    getBankAccountsByUid: build.query<
      GetBankAccountsByUidApiResponse,
      GetBankAccountsByUidApiArg
    >({
      query: (queryArg) => ({ url: `/bank-accounts/${queryArg.uid}` }),
    }),
    getChargesByUidPayouts: build.query<
      GetChargesByUidPayoutsApiResponse,
      GetChargesByUidPayoutsApiArg
    >({
      query: (queryArg) => ({ url: `/charges/${queryArg.uid}/payouts` }),
    }),
    getComplianceRequirements: build.query<
      GetComplianceRequirementsApiResponse,
      GetComplianceRequirementsApiArg
    >({
      query: () => ({ url: `/compliance_requirements` }),
    }),
    getContacts: build.query<GetContactsApiResponse, GetContactsApiArg>({
      query: (queryArg) => ({
        url: `/contacts`,
        params: {
          type: queryArg["type"],
          page: queryArg.page,
          perpage: queryArg.perpage,
        },
      }),
    }),
    postDac7ReportCreateDownloadUrl: build.mutation<
      PostDac7ReportCreateDownloadUrlApiResponse,
      PostDac7ReportCreateDownloadUrlApiArg
    >({
      query: (queryArg) => ({
        url: `/dac7-report/create-download-url`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getFees: build.query<GetFeesApiResponse, GetFeesApiArg>({
      query: (queryArg) => ({
        url: `/fees`,
        params: {
          page: queryArg.page,
          perpage: queryArg.perpage,
          fee_type: queryArg.feeType,
          payment_method: queryArg.paymentMethod,
        },
      }),
    }),
    getMovements: build.query<GetMovementsApiResponse, GetMovementsApiArg>({
      query: (queryArg) => ({
        url: `/movements`,
        params: {
          page: queryArg.page,
          perpage: queryArg.perpage,
          in: queryArg["in"],
          date_start: queryArg.dateStart,
          date_end: queryArg.dateEnd,
          force_simple_pagination: queryArg.forceSimplePagination,
        },
      }),
    }),
    getMovementsByUid: build.query<
      GetMovementsByUidApiResponse,
      GetMovementsByUidApiArg
    >({
      query: (queryArg) => ({ url: `/movements/${queryArg.uid}` }),
    }),
    postMovementsParentPaymentMethods: build.mutation<
      PostMovementsParentPaymentMethodsApiResponse,
      PostMovementsParentPaymentMethodsApiArg
    >({
      query: (queryArg) => ({
        url: `/movements/parent_payment_methods`,
        method: "POST",
      }),
    }),
    postMovementsExportCsv: build.mutation<
      PostMovementsExportCsvApiResponse,
      PostMovementsExportCsvApiArg
    >({
      query: (queryArg) => ({
        url: `/movements/export-csv`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getPaymentLinks: build.query<
      GetPaymentLinksApiResponse,
      GetPaymentLinksApiArg
    >({
      query: (queryArg) => ({
        url: `/payment_links`,
        params: {
          page: queryArg.page,
          perpage: queryArg.perpage,
          q: queryArg.q,
          status: queryArg.status,
          date_start: queryArg.dateStart,
          date_end: queryArg.dateEnd,
        },
      }),
    }),
    postPaymentLinks: build.mutation<
      PostPaymentLinksApiResponse,
      PostPaymentLinksApiArg
    >({
      query: (queryArg) => ({
        url: `/payment_links`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getPaymentLinksByUid: build.query<
      GetPaymentLinksByUidApiResponse,
      GetPaymentLinksByUidApiArg
    >({
      query: (queryArg) => ({ url: `/payment_links/${queryArg.uid}` }),
    }),
    putPaymentLinksByUid: build.mutation<
      PutPaymentLinksByUidApiResponse,
      PutPaymentLinksByUidApiArg
    >({
      query: (queryArg) => ({
        url: `/payment_links/${queryArg.uid}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deletePaymentLinksByUid: build.mutation<
      DeletePaymentLinksByUidApiResponse,
      DeletePaymentLinksByUidApiArg
    >({
      query: (queryArg) => ({
        url: `/payment_links/${queryArg.uid}`,
        method: "DELETE",
      }),
    }),
    postPaymentLinksByUidSend: build.mutation<
      PostPaymentLinksByUidSendApiResponse,
      PostPaymentLinksByUidSendApiArg
    >({
      query: (queryArg) => ({
        url: `/payment_links/${queryArg.uid}/send`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getProfilesByMerchantProfileUidBalance: build.query<
      GetProfilesByMerchantProfileUidBalanceApiResponse,
      GetProfilesByMerchantProfileUidBalanceApiArg
    >({
      query: (queryArg) => ({
        url: `/profiles/${queryArg.merchantProfileUid}/balance`,
      }),
    }),
    getProfiles: build.query<GetProfilesApiResponse, GetProfilesApiArg>({
      query: () => ({ url: `/profiles` }),
    }),
    getPurchases: build.query<GetPurchasesApiResponse, GetPurchasesApiArg>({
      query: (queryArg) => ({
        url: `/purchases`,
        params: {
          page: queryArg.page,
          perpage: queryArg.perpage,
          expand: queryArg.expand,
          q: queryArg.q,
          uid: queryArg.uid,
          refund_uid: queryArg.refundUid,
          payment_method: queryArg.paymentMethod,
          status: queryArg.status,
          date_start: queryArg.dateStart,
          date_end: queryArg.dateEnd,
          date_completed: queryArg.dateCompleted,
          date_combined: queryArg.dateCombined,
          order: queryArg.order,
          processed: queryArg.processed,
          unprocessed: queryArg.unprocessed,
          mandate_transaction_approved: queryArg.mandateTransactionApproved,
          mandate_transaction_processed: queryArg.mandateTransactionProcessed,
        },
      }),
    }),
    getPurchasesByUid: build.query<
      GetPurchasesByUidApiResponse,
      GetPurchasesByUidApiArg
    >({
      query: (queryArg) => ({ url: `/purchases/${queryArg.uid}` }),
    }),
    postReporting: build.mutation<
      PostReportingApiResponse,
      PostReportingApiArg
    >({
      query: (queryArg) => ({
        url: `/reporting`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postSearch: build.mutation<PostSearchApiResponse, PostSearchApiArg>({
      query: (queryArg) => ({
        url: `/search`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getSettings: build.query<GetSettingsApiResponse, GetSettingsApiArg>({
      query: () => ({ url: `/settings` }),
    }),
    getSettlements: build.query<
      GetSettlementsApiResponse,
      GetSettlementsApiArg
    >({
      query: (queryArg) => ({
        url: `/settlements`,
        params: {
          page: queryArg.page,
          perpage: queryArg.perpage,
          uid: queryArg.uid,
          status: queryArg.status,
          period: queryArg.period,
          date_start: queryArg.dateStart,
          date_end: queryArg.dateEnd,
          order: queryArg.order,
        },
      }),
    }),
    getSettlementsByUid: build.query<
      GetSettlementsByUidApiResponse,
      GetSettlementsByUidApiArg
    >({
      query: (queryArg) => ({
        url: `/settlements/${queryArg.uid}`,
        params: { expand: queryArg.expand },
      }),
    }),
    getSettlementsByUidSpecifications: build.query<
      GetSettlementsByUidSpecificationsApiResponse,
      GetSettlementsByUidSpecificationsApiArg
    >({
      query: (queryArg) => ({
        url: `/settlements/${queryArg.uid}/specifications`,
      }),
    }),
    getSettlementsByUidSpecificationsAndSpecificationUid: build.query<
      GetSettlementsByUidSpecificationsAndSpecificationUidApiResponse,
      GetSettlementsByUidSpecificationsAndSpecificationUidApiArg
    >({
      query: (queryArg) => ({
        url: `/settlements/${queryArg.uid}/specifications/${queryArg.specificationUid}`,
      }),
    }),
    getSettlementsByUidSpecificationsAndSpecificationUidRows: build.query<
      GetSettlementsByUidSpecificationsAndSpecificationUidRowsApiResponse,
      GetSettlementsByUidSpecificationsAndSpecificationUidRowsApiArg
    >({
      query: (queryArg) => ({
        url: `/settlements/${queryArg.uid}/specifications/${queryArg.specificationUid}/rows`,
        params: {
          date_start: queryArg.dateStart,
          date_end: queryArg.dateEnd,
          page: queryArg.page,
          perpage: queryArg.perpage,
          expand: queryArg.expand,
        },
      }),
    }),
    getStatisticsTotals: build.query<
      GetStatisticsTotalsApiResponse,
      GetStatisticsTotalsApiArg
    >({
      query: () => ({ url: `/statistics/totals` }),
    }),
    getStatisticsCharts: build.query<
      GetStatisticsChartsApiResponse,
      GetStatisticsChartsApiArg
    >({
      query: (queryArg) => ({ url: `/statistics/charts` }),
    }),
    getTickets: build.query<GetTicketsApiResponse, GetTicketsApiArg>({
      query: (queryArg) => ({
        url: `/tickets`,
        params: {
          page: queryArg.page,
          perpage: queryArg.perpage,
          q: queryArg.q,
          status: queryArg.status,
          category: queryArg.category,
          language: queryArg.language,
          order: queryArg.order,
        },
      }),
    }),
    postTickets: build.mutation<PostTicketsApiResponse, PostTicketsApiArg>({
      query: (queryArg) => ({
        url: `/tickets`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getTicketsByUid: build.query<
      GetTicketsByUidApiResponse,
      GetTicketsByUidApiArg
    >({
      query: (queryArg) => ({ url: `/tickets/${queryArg.uid}` }),
    }),
    getTopupsByUid: build.query<
      GetTopupsByUidApiResponse,
      GetTopupsByUidApiArg
    >({
      query: (queryArg) => ({ url: `/topups/${queryArg.uid}` }),
    }),
    postTopups: build.mutation<PostTopupsApiResponse, PostTopupsApiArg>({
      query: () => ({ url: `/topups`, method: "POST" }),
    }),
    getTransactions: build.query<
      GetTransactionsApiResponse,
      GetTransactionsApiArg
    >({
      query: (queryArg) => ({
        url: `/transactions`,
        params: {
          page: queryArg.page,
          perpage: queryArg.perpage,
          expand: queryArg.expand,
          q: queryArg.q,
          uid: queryArg.uid,
          refund_uid: queryArg.refundUid,
          payment_method: queryArg.paymentMethod,
          status: queryArg.status,
          date_start: queryArg.dateStart,
          date_end: queryArg.dateEnd,
          date_completed: queryArg.dateCompleted,
          date_combined: queryArg.dateCombined,
          order: queryArg.order,
          processed: queryArg.processed,
          unprocessed: queryArg.unprocessed,
          mandate_transaction_approved: queryArg.mandateTransactionApproved,
          mandate_transaction_processed: queryArg.mandateTransactionProcessed,
        },
      }),
    }),
    postTransactions: build.mutation<
      PostTransactionsApiResponse,
      PostTransactionsApiArg
    >({
      query: (queryArg) => ({
        url: `/transactions`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getTransactionsByUid: build.query<
      GetTransactionsByUidApiResponse,
      GetTransactionsByUidApiArg
    >({
      query: (queryArg) => ({ url: `/transactions/${queryArg.uid}` }),
    }),
    getTransactionsByUidLog: build.query<
      GetTransactionsByUidLogApiResponse,
      GetTransactionsByUidLogApiArg
    >({
      query: (queryArg) => ({ url: `/transactions/${queryArg.uid}/log` }),
    }),
    getTransactionsByUidPayouts: build.query<
      GetTransactionsByUidPayoutsApiResponse,
      GetTransactionsByUidPayoutsApiArg
    >({
      query: (queryArg) => ({ url: `/transactions/${queryArg.uid}/payouts` }),
    }),
    getTransactionsByTransactionUidRefundsAndRefundUidPayouts: build.query<
      GetTransactionsByTransactionUidRefundsAndRefundUidPayoutsApiResponse,
      GetTransactionsByTransactionUidRefundsAndRefundUidPayoutsApiArg
    >({
      query: (queryArg) => ({
        url: `/transactions/${queryArg.transactionUid}/refunds/${queryArg.refundUid}/payouts`,
      }),
    }),
    getTransactionsByUidRefundable: build.query<
      GetTransactionsByUidRefundableApiResponse,
      GetTransactionsByUidRefundableApiArg
    >({
      query: (queryArg) => ({
        url: `/transactions/${queryArg.uid}/refundable`,
      }),
    }),
    postTransactionByUidRefunds: build.mutation<
      PostTransactionByUidRefundsApiResponse,
      PostTransactionByUidRefundsApiArg
    >({
      query: (queryArg) => ({
        url: `/transaction/${queryArg.uid}/refunds`,
        method: "POST",
      }),
    }),
    getTransactionsByUidTracking: build.query<
      GetTransactionsByUidTrackingApiResponse,
      GetTransactionsByUidTrackingApiArg
    >({
      query: (queryArg) => ({
        url: `/transactions/${queryArg.uid}/tracking`,
        params: { page: queryArg.page, perpage: queryArg.perpage },
      }),
    }),
    getTransactionsByUidTrackingAndTrackingUid: build.query<
      GetTransactionsByUidTrackingAndTrackingUidApiResponse,
      GetTransactionsByUidTrackingAndTrackingUidApiArg
    >({
      query: (queryArg) => ({
        url: `/transactions/${queryArg.uid}/tracking/${queryArg.trackingUid}`,
      }),
    }),
    deleteUser: build.mutation<DeleteUserApiResponse, DeleteUserApiArg>({
      query: () => ({ url: `/user`, method: "DELETE" }),
    }),
    getUsersWhoami: build.query<
      GetUsersWhoamiApiResponse,
      GetUsersWhoamiApiArg
    >({
      query: () => ({ url: `/users/whoami` }),
    }),
    postWithdrawals: build.mutation<
      PostWithdrawalsApiResponse,
      PostWithdrawalsApiArg
    >({
      query: (queryArg) => ({
        url: `/withdrawals`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getWithdrawalByUid: build.query<
      GetWithdrawalByUidApiResponse,
      GetWithdrawalByUidApiArg
    >({
      query: (queryArg) => ({ url: `/withdrawal/${queryArg.uid}` }),
    }),
    getWithdrawalsByUidPayouts: build.query<
      GetWithdrawalsByUidPayoutsApiResponse,
      GetWithdrawalsByUidPayoutsApiArg
    >({
      query: (queryArg) => ({ url: `/withdrawals/${queryArg.uid}/payouts` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as merchantApi };
export type GetBalanceApiResponse = /** status 200 Success */ {
  data?: Balance;
};
export type GetBalanceApiArg = void;
export type GetBankAccountsApiResponse =
  /** status 200 Success */ PaginatedResponse & {
    data?: BankAccount[];
  };
export type GetBankAccountsApiArg = {
  /** Status */
  status?: string;
  /** Page number */
  page?: number;
  /** Define number of results per page */
  perpage?: number;
};
export type GetBankAccountsByUidApiResponse = /** status 200 Success */ {
  data?: BankAccount;
};
export type GetBankAccountsByUidApiArg = {
  /** uid of bankaccount to show */
  uid: string;
};
export type GetChargesByUidPayoutsApiResponse = /** status 200 Success */ {
  data?: Payout[];
};
export type GetChargesByUidPayoutsApiArg = {
  /** uid of charge to show */
  uid: string;
};
export type GetComplianceRequirementsApiResponse =
  /** status 200 Success */ PaginatedResponse & {
    data?: ComplianceRequirement[];
  };
export type GetComplianceRequirementsApiArg = void;
export type GetContactsApiResponse =
  /** status 200 Success */ PaginatedResponse & {
    data?: Contact[];
  };
export type GetContactsApiArg = {
  /** Type */
  type?: string;
  /** Page number */
  page?: number;
  /** Define number of results per page */
  perpage?: number;
};
export type PostDac7ReportCreateDownloadUrlApiResponse =
  /** status 200 Success */ {
    livemode?: boolean;
    /** One time link to download dac7 report. */
    report_download_url?: string;
  };
export type PostDac7ReportCreateDownloadUrlApiArg = {
  body: {
    /** Language code for the pdf report. */
    language?: ("de" | "en" | "fr" | "nl") | null;
    /** Year of the DAC7 Report */
    reporting_year?: number | null;
  };
};
export type GetFeesApiResponse = /** status 200 Success */ PaginatedResponse & {
  data?: Fee[];
};
export type GetFeesApiArg = {
  /** Page number */
  page?: number;
  /** Define number of results per page */
  perpage?: number;
  /** Filter by fee type */
  feeType?: string;
  /** Filter by payment method */
  paymentMethod?: string;
};
export type GetMovementsApiResponse =
  /** status 200 Success */ PaginatedResponse & {
    data?: Movement[];
  };
export type GetMovementsApiArg = {
  /** Page number */
  page?: number;
  /** Define number of results per page */
  perpage?: number;
  /** in */
  in?: boolean;
  /** Define the starting date of which the movements should be fetched */
  dateStart?: string;
  /** Define the ending date of which the movements should be fetched */
  dateEnd?: string;
  /** Should force simple pagination(no totals etc.) */
  forceSimplePagination?: boolean;
};
export type GetMovementsByUidApiResponse = /** status 200 Success */ {
  data?: Movement;
};
export type GetMovementsByUidApiArg = {
  /** uid of movement to show */
  uid: string;
};
export type PostMovementsParentPaymentMethodsApiResponse =
  /** status 200 Success */ {
    data?: ParentPaymentMethod;
  };
export type PostMovementsParentPaymentMethodsApiArg = {
  /** array of uids of movement */
  uid: any;
};
export type PostMovementsExportCsvApiResponse = /** status 200 Success */ Blob;
export type PostMovementsExportCsvApiArg = {
  /** Request body for generating movement CSV export */
  body: {
    /** Created at date_start for exporting movements */
    date_start?: string | null;
    /** Created at date_end for exporting movements */
    date_end?: string | null;
  };
};
export type GetPaymentLinksApiResponse =
  /** status 200 Success */ PaginatedResponse & {
    data?: PaymentLink[];
  };
export type GetPaymentLinksApiArg = {
  /** Page number */
  page?: number;
  /** Define number of results per page */
  perpage?: number;
  /** Search by UID of payment link, or title of the link or products */
  q?: string;
  /** Filter on payment link status */
  status?: string;
  /** Define the starting date of which the payment links should be fetched */
  dateStart?: string;
  /** Define the ending date of which the payment links should be fetched */
  dateEnd?: string;
};
export type PostPaymentLinksApiResponse = /** status 200 Success */ {
  data?: PaymentLink;
};
export type PostPaymentLinksApiArg = {
  /** Request body for creating a payment link */
  body: {
    /** title of the payment link */
    title?: string;
    /** Merchant profile uid for which payment link will be created */
    profile_uid?: string;
    /** locale of payment link */
    locale?: string;
    /** Expiry date of payment link */
    date_expired?: string;
    /** If payment link needs checkout  */
    checkout?: boolean;
    /** Skip checkout page when checkout is enabled */
    skip_confirmation_page?: boolean | null;
    /** Return URL after payment is completed */
    return_url?: boolean | null;
    /** URL for sending status change notifications */
    notify_url?: string | null;
    /** payment currency */
    currency?: string | null;
    /** Products or services */
    products?: {
      name?: string;
      /** price in cents */
      price?: number;
      quantity?: number;
    }[];
  };
};
export type GetPaymentLinksByUidApiResponse = /** status 200 Success */ {
  data?: PaymentLink & {
    completed_transaction?: Transaction;
  };
};
export type GetPaymentLinksByUidApiArg = {
  /** UID of payment link */
  uid: string;
};
export type PutPaymentLinksByUidApiResponse = /** status 200 Success */ {
  data?: PaymentLink;
};
export type PutPaymentLinksByUidApiArg = {
  /** UID of payment link */
  uid: string;
  /** Request body for creating a payment link */
  body: {
    /** title of the payment link */
    title?: string;
    /** locale of payment link */
    locale?: string;
    /** Expiry date of payment link */
    date_expired?: string;
    /** If payment link needs checkout  */
    checkout?: boolean;
    /** Skip checkout page when checkout is enabled */
    skip_confirmation_page?: boolean | null;
    /** Return URL after payment is completed */
    return_url?: string | null;
    /** URL for sending status change notifications */
    notify_url?: string | null;
    /** payment currency */
    currency?: string | null;
    /** Products or services */
    products?: {
      name?: string;
      /** price in cents */
      price?: number;
      quantity?: number;
    }[];
  };
};
export type DeletePaymentLinksByUidApiResponse = /** status 200 Success */ {
  livemode?: boolean;
  /** UID of payment link that has been deleted */
  uid?: string;
  deleted?: boolean;
};
export type DeletePaymentLinksByUidApiArg = {
  /** UID of payment link */
  uid: string;
};
export type PostPaymentLinksByUidSendApiResponse = /** status 200 Success */ {
  livemode?: boolean;
  /** UID of payment link that has been sent */
  uid?: string;
  sent?: boolean;
};
export type PostPaymentLinksByUidSendApiArg = {
  /** UID of payment link */
  uid: string;
  body: {
    /** Name of the recipient */
    name?: string;
    /** E-mail of the recipient */
    email?: string;
    /** E-mail that recipient can reply to */
    reply_to_email?: string;
    /** Email of the customer */
    message?: string | null;
  };
};
export type GetProfilesByMerchantProfileUidBalanceApiResponse =
  /** status 200 Success */ {
    data?: Balance;
  };
export type GetProfilesByMerchantProfileUidBalanceApiArg = {
  /** Merchant profile uid */
  merchantProfileUid: string;
};
export type GetProfilesApiResponse =
  /** status 200 Success */ PaginatedResponse & {
    data?: Profile[];
  };
export type GetProfilesApiArg = void;
export type GetPurchasesApiResponse =
  /** status 200 Success */ PaginatedResponse & {
    data?: Purchase[];
  };
export type GetPurchasesApiArg = {
  /** Page number */
  page?: number;
  /** Define number of results per page */
  perpage?: number;
  /** Expand */
  expand?: string;
  /** Search */
  q?: string;
  /** Transaction UID */
  uid?: string;
  /** Refund UID */
  refundUid?: string;
  /** Payment method of transactions */
  paymentMethod?: string;
  /** Status of transactions */
  status?: string;
  /** Define the starting date of which a transaction should be created at or after, we default to 7 days ago */
  dateStart?: string;
  /** Define the ending date of which a transaction should be created before or at, we default to today */
  dateEnd?: string;
  /** Define the completion date of which a transaction should be completed at */
  dateCompleted?: string;
  /** Define the date of which a transaction should be either completed at or created at */
  dateCombined?: string;
  /** Order results */
  order?: string;
  /** Order processed */
  processed?: boolean;
  /** Order not processed */
  unprocessed?: boolean;
  /** Mandate transaction approved */
  mandateTransactionApproved?: boolean;
  /** Mandate transaction processed */
  mandateTransactionProcessed?: boolean;
};
export type GetPurchasesByUidApiResponse = /** status 200 Success */ {
  data?: Purchase;
};
export type GetPurchasesByUidApiArg = {
  /** uid of transaction to show */
  uid: string;
};
export type PostReportingApiResponse = unknown;
export type PostReportingApiArg = {
  body: {
    error_component?: any;
    error_message?: any;
    error_location?: any;
    error_stack?: any;
  };
};
export type PostSearchApiResponse =
  /** status 200 Success */ PaginatedResponse & {
    data?: Movement[];
  };
export type PostSearchApiArg = {
  body: {
    q?: any;
  };
};
export type GetSettingsApiResponse = /** status 200 Success */ {
  data?: Settings;
};
export type GetSettingsApiArg = void;
export type GetSettlementsApiResponse =
  /** status 200 Success */ PaginatedResponse & {
    data?: Settlement[];
  };
export type GetSettlementsApiArg = {
  /** Page number */
  page?: number;
  /** Define number of results per page */
  perpage?: number;
  /** Settlement UID */
  uid?: string;
  /** Status of settlement */
  status?: string;
  /** Period of which a settlement must begin and end within */
  period?: string;
  /** Define the starting date of which a settlement should be created at or after */
  dateStart?: string;
  /** Define the ending date of which a settlement should be created before or at */
  dateEnd?: string;
  /** Order results */
  order?: string;
};
export type GetSettlementsByUidApiResponse = /** status 200 Success */ {
  data?: Settlement;
};
export type GetSettlementsByUidApiArg = {
  /** uid of settlement to show */
  uid: string;
  /** Expand */
  expand?: string;
};
export type GetSettlementsByUidSpecificationsApiResponse =
  /** status 200 Success */ PaginatedResponse & {
    data?: Settlement[];
  };
export type GetSettlementsByUidSpecificationsApiArg = {
  /** uid of settlement to show */
  uid: string;
};
export type GetSettlementsByUidSpecificationsAndSpecificationUidApiResponse =
  /** status 200 Success */ {
    data?: SettlementSpecification;
  };
export type GetSettlementsByUidSpecificationsAndSpecificationUidApiArg = {
  /** uid of settlement to show */
  uid: string;
  /** uid of specification to show */
  specificationUid: string;
};
export type GetSettlementsByUidSpecificationsAndSpecificationUidRowsApiResponse =
  /** status 200 Success */ PaginatedResponse & {
    data?: SettlementSpecificationRow[];
  };
export type GetSettlementsByUidSpecificationsAndSpecificationUidRowsApiArg = {
  /** Define the starting date of which a transaction should be created at or after, we default to 7 days ago */
  dateStart?: string;
  /** Define the ending date of which a transaction should be created before or at, we default to today */
  dateEnd?: string;
  /** Page number */
  page?: number;
  /** Define number of results per page */
  perpage?: number;
  /** Expand */
  expand?: string;
  /** uid of settlement to show */
  uid: string;
  /** uid of specification to show */
  specificationUid: string;
};
export type GetStatisticsTotalsApiResponse = /** status 200 Success */ {
  data?: StatisticsTotal;
};
export type GetStatisticsTotalsApiArg = void;
export type GetStatisticsChartsApiResponse = /** status 200 Success */ {
  data?: StatisticsCharts;
};
export type GetStatisticsChartsApiArg = {
  /** Date of the period to start from */
  dateStart: string;
  /** Date of the period to end from */
  dateEnd: string;
};
export type GetTicketsApiResponse =
  /** status 200 Success */ PaginatedResponse & {
    data?: Ticket[];
  };
export type GetTicketsApiArg = {
  /** Page number */
  page?: number;
  /** Define number of results per page */
  perpage?: number;
  /** Search on: uid, subject, customer email or customer name */
  q?: string;
  /** Status of ticket */
  status?: string;
  /** Category of ticket */
  category?: string;
  /** Language of ticket */
  language?: string;
  /** Order results */
  order?: string;
};
export type PostTicketsApiResponse = /** status 200 Success */ {
  data?: Ticket;
};
export type PostTicketsApiArg = {
  body: {
    customer_phonenumber?: any | null;
    customer_emailaddress?: any;
    customer_name?: any;
    subject?: any;
    message?: any;
    category?: any;
    reference?: any;
    locale?: any;
  };
};
export type GetTicketsByUidApiResponse = /** status 200 Success */ {
  data?: Ticket;
};
export type GetTicketsByUidApiArg = {
  /** uid of ticket to show */
  uid: string;
};
export type GetTopupsByUidApiResponse = /** status 200 Success */ {
  data?: Topup;
};
export type GetTopupsByUidApiArg = {
  /** uid of topup to show */
  uid: string;
};
export type PostTopupsApiResponse = /** status 200 Success */ {
  data?: Topup;
};
export type PostTopupsApiArg = void;
export type GetTransactionsApiResponse =
  /** status 200 Success */ PaginatedResponse & {
    data?: Transaction[];
  };
export type GetTransactionsApiArg = {
  /** Page number */
  page?: number;
  /** Define number of results per page */
  perpage?: number;
  /** Expand */
  expand?: string;
  /** Search */
  q?: string;
  /** Transaction UID */
  uid?: string;
  /** Refund UID */
  refundUid?: string;
  /** Payment method of transactions */
  paymentMethod?: string;
  /** Status of transactions */
  status?: string;
  /** Define the starting date of which a transaction should be created at or after, we default to 7 days ago */
  dateStart?: string;
  /** Define the ending date of which a transaction should be created before or at, we default to today */
  dateEnd?: string;
  /** Define the completion date of which a transaction should be completed at */
  dateCompleted?: string;
  /** Define the date of which a transaction should be either completed at or created at */
  dateCombined?: string;
  /** Order results */
  order?: string;
  /** Order processed */
  processed?: boolean;
  /** Order not processed */
  unprocessed?: boolean;
  /** Mandate transaction approved */
  mandateTransactionApproved?: boolean;
  /** Mandate transaction processed */
  mandateTransactionProcessed?: boolean;
};
export type PostTransactionsApiResponse = /** status 200 Success */ {
  data?: Transaction;
};
export type PostTransactionsApiArg = {
  body: {
    profile_uid?: string;
    total_price?: number;
    return_url?: string;
    locale?: string;
  };
};
export type GetTransactionsByUidApiResponse = /** status 200 Success */ {
  data?: Transaction;
};
export type GetTransactionsByUidApiArg = {
  /** uid of transaction to show */
  uid: string;
};
export type GetTransactionsByUidLogApiResponse = /** status 200 Success */ {
  data?: TransactionLog[];
};
export type GetTransactionsByUidLogApiArg = {
  /** uid of transaction to show */
  uid: string;
};
export type GetTransactionsByUidPayoutsApiResponse = /** status 200 Success */ {
  data?: Payout[];
};
export type GetTransactionsByUidPayoutsApiArg = {
  /** uid of transaction to show */
  uid: string;
};
export type GetTransactionsByTransactionUidRefundsAndRefundUidPayoutsApiResponse =
  /** status 200 Success */ {
    data?: Payout[];
  };
export type GetTransactionsByTransactionUidRefundsAndRefundUidPayoutsApiArg = {
  /** uid of transaction */
  transactionUid: string;
  /** uid of refund transaction */
  refundUid: string;
};
export type GetTransactionsByUidRefundableApiResponse =
  /** status 200 Success */ {
    data?: TransactionRefundable;
  };
export type GetTransactionsByUidRefundableApiArg = {
  /** uid of transaction to show */
  uid: string;
};
export type PostTransactionByUidRefundsApiResponse = /** status 200 Success */ {
  data?: Transaction;
};
export type PostTransactionByUidRefundsApiArg = {
  /** UID of transaction */
  uid: string;
};
export type GetTransactionsByUidTrackingApiResponse =
  /** status 200 Success */ {
    data?: TransactionTracking[];
  };
export type GetTransactionsByUidTrackingApiArg = {
  /** Page number */
  page?: number;
  /** Define number of results per page */
  perpage?: number;
  /** uid of transaction to show */
  uid: string;
};
export type GetTransactionsByUidTrackingAndTrackingUidApiResponse =
  /** status 200 Success */ {
    data?: TransactionTracking;
  };
export type GetTransactionsByUidTrackingAndTrackingUidApiArg = {
  /** uid of transaction to show */
  uid: string;
  /** uid of tracking to show */
  trackingUid: string;
};
export type DeleteUserApiResponse = /** status 200 Success */
  | 200
  | 300
  | 301
  | 400
  | 403;
export type DeleteUserApiArg = void;
export type GetUsersWhoamiApiResponse = /** status 200 Success */ {
  data?: UsersWhoami;
};
export type GetUsersWhoamiApiArg = void;
export type PostWithdrawalsApiResponse = /** status 200 Success */ {
  data?: Withdrawal;
};
export type PostWithdrawalsApiArg = {
  body: {
    merchant_profile_uid?: any;
    amount1?: any;
    amount2?: any;
    description?: any;
  };
};
export type GetWithdrawalByUidApiResponse = /** status 200 Success */ {
  data?: Withdrawal;
};
export type GetWithdrawalByUidApiArg = {
  /** uid of withdrawal to show */
  uid: string;
};
export type GetWithdrawalsByUidPayoutsApiResponse = /** status 200 Success */ {
  data?: Payout[];
};
export type GetWithdrawalsByUidPayoutsApiArg = {
  /** uid of withdrawal to show */
  uid: string;
};
export type Balance = {
  object?: string;
  amount?: number;
  amount_planned?: number;
  amount_reserved?: number;
  currency?: string;
  /** Only when balance is a merchant balance */
  profile_balances?: {
    object?: string;
    uid?: string;
    amount?: number;
    amount_planned?: number;
    amount_reserved?: number;
    currency?: string;
  }[];
};
export type PaginatedResponse = {
  data?: any[];
  links?: {
    first?: string;
    last?: string | null;
    prev?: string | null;
    next?: string | null;
  };
  meta?: {
    current_page?: number;
    last_page?: number;
    total?: number;
    links?: {
      url?: string | null;
      label?: string;
      active?: boolean;
    }[];
    per_page?: number;
    from?: number;
    to?: number;
    path?: string;
  };
};
export type BankAccount = {
  uid?: string;
  object?: string;
  created?: number;
  updated?: number;
  verified?: number;
  verified_with?: string;
  verification_url?: string;
  status?: string;
  account?: {
    account_iban?: string | null;
    account_name?: string | null;
  };
  bank?: {
    bic?: string | null;
  };
  reference?: string | null;
  return_url?: string | null;
  notify_url?: string | null;
  is_default?: boolean;
};
export type Payout = {
  uid?: string;
  object?: string;
  paid?: string | null;
  amount?: number;
  currency?: string;
  description?: string;
  status?: string;
  receiver_details?: object;
  created?: string;
  updated?: string;
};
export type ComplianceRequirement = {
  type?: string;
  status?: string;
  object_type?: string;
  object_uid?: string | null;
  object_url?: string;
  object_redirect_url?: string | null;
};
export type Contact = {
  uid?: string;
  object?: string;
  created?: number;
  updated?: number;
  verified?: number | null;
  verified_with?: string | null;
  status?: string;
  verification_url?: string;
  type?: string;
  title?: string | null;
  name_initials?: string | null;
  name_first?: string | null;
  name_last?: string | null;
  names_given?: string | null;
  birthdate?: string | null;
  partner_name_last?: string | null;
  emailaddresses?: {
    uid?: string;
    object?: string;
    created?: string;
    updated?: string;
    verified?: string | null;
    emailaddress?: string;
  }[];
  phonenumbers?: {
    uid?: string;
    object?: string;
    created?: string;
    updated?: string;
    verified?: string | null;
    phonenumber?: string;
    status?: string | null;
  }[];
};
export type Fee = {
  uid?: string;
  object?: string;
  created?: number;
  updated?: number;
  type?: string;
  payment_method?: string;
  fixed_fee?: number;
  variable_fee?: number;
  variable_fee_minimum_amount?: number;
  variable_fee_maximum_amount?: number;
  range_type?: string;
  range_start?: string;
  range_end?: string;
  textual?: string;
};
export type Movement = {
  uid?: string;
  object?: string;
  description?: string | null;
  payment_method?: string;
  parent_payment_method?: string;
  status?: string;
  in?: boolean;
  amount?: number;
  costs?: number;
  currency?: string;
  created?: number;
  date?: number;
  date_settled?: number | null;
};
export type ParentPaymentMethod = {
  uid?: string;
  parent_payment_method?: string;
}[];
export type PaymentLink = {
  uid?: string;
  object?: string;
  title?: string;
  created?: number;
  locale?: string;
  profile_uid?: string;
  profile_name?: string;
  status?: string;
  payment_url?: string;
  return_url?: string | null;
  notify_url?: string | null;
  total_amount?: number;
  currency?: string;
  products?: {
    name?: string;
    price?: number;
    quantity?: number;
    total_amount?: number;
  }[];
  transactions_count?: number;
  checkout?: boolean;
  skip_confirmation_page?: boolean;
  date_created?: string;
  date_expired?: string;
  date_completed?: string | null;
  payment_link_recipients?: {
    name?: string;
    type?: string;
    email?: string;
    reply_to_email?: string;
    date_sent?: string | null;
  }[];
};
export type Transaction = {
  uid?: string;
  object?: string;
  created?: number;
  updated?: number;
  completed?: number | null;
  merchant_uid?: string;
  profile_uid?: string;
  has_checkout?: boolean;
  payment_method?: string;
  payment_flow?: string;
  payment_details?: {
    reference?: string;
    code?: string | null;
    message?: string | null;
  };
  amount?: number;
  return_url?: string;
  redirect_url?: string | null;
  notify_url?: string | null;
  status?: string;
  metadata?: {
    key?: string;
    value?: string;
  }[];
  statuses?: {
    uid?: string;
    object?: string;
    created?: number;
    updated?: number;
    status?: string;
  }[];
  order?: {
    uid?: string;
    object?: string;
    created?: number;
    updated?: number;
    processed?: boolean;
    price?: number;
    shipping?: number;
    discount?: number;
    street?: string;
    housenumber?: string;
    housenumber_addition?: string | null;
    zipcode?: string;
    city?: string;
    state?: string | null;
    country?: string;
    customer?: {
      uid?: string;
      object?: string;
      created?: number;
      updated?: number;
      name_first?: string | null;
      name_prefix?: string | null;
      name_last?: string | null;
      birthdate?: string | null;
      emailaddress?: string | null;
      phonenumber?: string | null;
      company?: string | null;
    };
    products?: {
      uid?: string;
      object?: string;
      created?: number;
      updated?: number;
      name?: string;
      ean?: string | null;
      code?: string | null;
      quantity?: number;
      vat_rate?: object | null;
      price?: number;
    }[];
  };
  escrow?: {
    uid?: string;
    object?: string;
    period?: number;
    start?: number | null;
    end?: number | null;
  } | null;
  fees?: {
    merchant_gateway_fee?: number;
    merchant_transaction_fee?: number;
    merchant_order_fee?: number;
    merchant_payable_amount?: number;
    gateway_fee?: number;
    transaction_fee?: number;
    order_fee?: number;
    payable_amount?: number;
  };
  refunds?: {
    uid?: string;
    object?: string;
    created?: number;
    updated?: number;
    paid?: number | null;
    amount?: number;
    status?: string;
    message?: string | null;
    internal_reason?: string | null;
    fees?: {
      merchant_gateway_fee?: number;
      merchant_transaction_fee?: number;
      merchant_order_fee?: number;
      merchant_payable_amount?: number;
      gateway_fee?: number;
      transaction_fee?: number;
      order_fee?: number;
      payable_amount?: number;
    };
    payout_description?: string | null;
    metadata?: {
      key?: string;
      value?: string;
    }[];
  }[];
};
export type Profile = {
  uid?: string;
  object?: string;
  created?: number;
  updated?: number;
  status?: string;
  name?: string;
  sector?: string | null;
  url?: string;
  po_number?: string | null;
  contact?: {
    phonenumber?: string | null;
    emailaddress?: string | null;
  };
  bank_account?: any | null;
  payment_methods?: {
    ""?: string;
  }[];
  metadata?: {
    key?: string;
    value?: string;
  }[];
  virtual_ibans?: {
    uid?: string;
    object?: string;
    account_holder?: string;
    iban?: string;
    bic?: string;
    country?: string;
    currency?: string;
  }[];
};
export type Purchase = {
  uid?: string;
  object?: string;
  created?: number;
  updated?: number;
  completed?: number | null;
  payment_method?: string;
  status?: string;
  date_paid?: number | null;
  amount?: number;
  order?: {
    uid?: string;
    object?: string;
    products?: {
      created?: number;
      updated?: number;
      name?: string;
      quantity?: number;
      price?: {
        amount?: number;
        currency?: string;
      }[];
    }[];
  };
  escrow?: {
    uid?: string;
    object?: string;
    period?: number;
    start?: number | null;
    end?: number | null;
  } | null;
};
export type Settings = {
  compliance_overview_url?: string;
  settlement_interval?: string;
  has_unverified_compliance_requirement?: boolean;
  has_pending_compliance_requirement?: boolean;
  has_open_tickets?: boolean;
  has_virtual_iban?: boolean;
  has_purchases?: boolean;
  permissions?: {
    "payment-links"?: boolean;
  }[];
  has_dac7_report?: boolean;
  dac7_report_years?: any;
  change_bank_account_url?: string | null;
  ideal_skip_issuer_selection?: boolean;
};
export type SettlementSpecification = {
  uid?: string;
  object?: string;
  created?: number;
  updated?: number;
  paid?: number | null;
  period_start?: number;
  period_end?: number;
  status?: string;
  total_number_of_transactions?: number;
  number_of_transactions?: number;
  number_of_refunds?: number;
  number_of_withdrawals?: number;
  number_of_mandates?: number;
  number_of_internal_transfers?: number;
  number_of_multi_transactions?: number;
  total_volume?: number;
  transaction_volume?: number;
  refund_volume?: number;
  withdrawal_volume?: number;
  mandate_volume?: number;
  internal_transfer_volume?: number;
  multi_transaction_volume?: number;
  total_transaction_costs?: number;
  transaction_costs?: number;
  refund_costs?: number;
  withdrawal_costs?: number;
  mandate_costs?: number;
  internal_transfer_costs?: number;
  multi_transaction_costs?: number;
  total_order_fees?: number;
  total_refund_fees?: number;
  total_gateway_fees?: number;
  total_amount?: number;
  amount_paid?: number;
  amount_payable?: number;
  po_number?: number | null;
};
export type Settlement = {
  uid?: string;
  object?: string;
  created?: number;
  updated?: number;
  paid?: number | null;
  period_start?: number;
  period_end?: number;
  status?: string;
  total_number_of_transactions?: number;
  number_of_transactions?: number;
  number_of_refunds?: number;
  number_of_withdrawals?: number;
  number_of_mandates?: number;
  number_of_internal_transfers?: number;
  number_of_multi_transactions?: number;
  total_volume?: number;
  transaction_volume?: number;
  refund_volume?: number;
  withdrawal_volume?: number;
  mandate_volume?: number;
  internal_transfer_volume?: number;
  multi_transaction_volume?: number;
  total_transaction_costs?: number;
  transaction_costs?: number;
  refund_costs?: number;
  withdrawal_costs?: number;
  mandate_costs?: number;
  internal_transfer_costs?: number;
  multi_transaction_costs?: number;
  total_order_fees?: number;
  total_refund_fees?: number;
  total_gateway_fees?: number;
  total_amount?: number;
  amount_paid?: number;
  amount_payable?: number;
  payout_type?: string;
  interval?: string;
  po_number?: number | null;
  specifications?: SettlementSpecification[];
};
export type SettlementSpecificationRow = {
  object?: string;
  created?: number;
  updated?: number;
  date?: number;
  type?: string;
  reference?: string;
  volume?: number;
  fees?: {
    transaction_fee?: number;
    order_fee?: number;
    refund_fee?: number;
    withdrawal_fee?: number;
    mandate_fee?: number;
    internal_transfer_fee?: number;
    multi_transaction_fee?: number;
    gateway_fee?: number;
  };
  amount?: number;
  amount_paid?: number;
  amount_payable?: number;
  payout?: {
    amount?: number;
    created?: number;
    currency?: string;
    description?: string;
    object?: string;
    paid?: number | null;
    status?: string;
    uid?: number;
    updated?: number;
    receiver_details?: {
      account?: string;
      financial_institution_identifier?: string;
      name?: string;
      type?: string;
    };
  };
};
export type StatisticsTotal = {
  /** The number of transactions */
  total?: number;
  /** The total amount of the summed transactions */
  amount?: number;
};
export type StatisticsCharts = {
  /** All the date entries/labels in Y-m-d format. */
  labels?: string[];
  /** Incoming totals per day */
  incoming?: any[];
  /** Outgoing totals per day */
  outgoing?: any[];
  /** Refund totals per day */
  refunds?: any[];
};
export type Ticket = {
  uid?: string;
  object?: string;
  created?: number;
  updated?: number;
  category?: string;
  status?: string;
  token?: string;
  subject?: string;
  url?: string;
};
export type Topup = {
  uid?: string;
  object?: string;
  created?: string;
  updated?: string;
  status?: string;
  redirect_url?: string;
  transaction_status?: string;
  ownable_object_uid?: string;
  ownable_object_type?: string;
  merchant_transaction_uid?: string;
};
export type TransactionLog = {
  uid?: string;
  object?: string;
  created?: number;
  updated?: number;
  status?: string;
};
export type TransactionRefundable = {
  minimum_refundable_amount?: number;
  maximum_refundable_amount?: number;
  can_refund?: boolean;
  can_not_refund_reason?: string;
  has_active_topup?: boolean;
  show_topup?: boolean;
  payment_methods?: object;
};
export type TransactionTracking = {
  uid?: string;
  object?: string;
  created?: number;
  updated?: number;
  shipped?: number | null;
  tracking_number?: string | null;
  tracking_reference?: string | null;
  tracking_origin?: {
    address_line_1?: string | null;
    address_line_2?: string | null;
    housenumber?: string | null;
    housenumber_addition?: string | null;
    zipcode?: string | null;
    city?: string | null;
    country?: string | null;
  };
  tracking_destination?: {
    address_line_1?: string | null;
    address_line_2?: string | null;
    housenumber?: string | null;
    housenumber_addition?: string | null;
    zipcode?: string | null;
    city?: string | null;
    country?: string | null;
  };
  tracking_carrier?: {
    name?: string | null;
  };
};
export type UsersPartner = {
  uid?: string;
  name?: string;
  currency?: string;
  since?: string;
  urls?: {
    support?: string;
    logo?: string;
  };
};
export type UsersMerchant = {
  uid?: string;
  name?: string;
  email?: string;
  /** Merchant type */
  type?: "open" | "consumer" | "business";
  /** Status of the merchant object. */
  status?:
    | (
        | "empty"
        | "new"
        | "pending"
        | "live"
        | "suspended"
        | "blocked"
        | "terminated"
        | "deleted"
      )
    | null;
  since?: string;
  partner?: UsersPartner;
};
export type UsersWhoami = {
  /** unique identifier of user */
  uid?: string;
  /** type of the user, which will have value 'merchant' */
  type?: string;
  given_name?: string;
  family_name?: string;
  email?: string;
  merchant?: UsersMerchant;
  merchants?: UsersMerchant[];
  partner?: UsersPartner;
};
export type Withdrawal = {
  uid?: string;
  object?: string;
  created?: number;
  updated?: number;
  completed?: string | null;
  execution?: string | null;
  expected?: string | null;
  status?: string;
  status_reason?: string | null;
  statuses?: {
    uid?: string;
    object?: string;
    created?: number;
    updated?: number;
    status?: string;
  }[];
  reference?: string | null;
  amount?: number;
  receiver?: string;
  receiver_details?: {
    object?: string;
    receiver_name?: string;
    receiver_account?: number;
    receiver_iban?: number | null;
    receiver_sort_code?: string | null;
    receiver_bic?: string | null;
    receiver_type?: string | null;
  }[];
  fees?: {
    gateway_fee?: number;
    withdrawal_fee?: number;
    order_fee?: number;
  }[];
  description?: string | null;
  notify_url?: string | null;
};
export const {
  useGetBalanceQuery,
  useGetBankAccountsQuery,
  useGetBankAccountsByUidQuery,
  useGetChargesByUidPayoutsQuery,
  useGetComplianceRequirementsQuery,
  useGetContactsQuery,
  usePostDac7ReportCreateDownloadUrlMutation,
  useGetFeesQuery,
  useGetMovementsQuery,
  useGetMovementsByUidQuery,
  usePostMovementsParentPaymentMethodsMutation,
  usePostMovementsExportCsvMutation,
  useGetPaymentLinksQuery,
  usePostPaymentLinksMutation,
  useGetPaymentLinksByUidQuery,
  usePutPaymentLinksByUidMutation,
  useDeletePaymentLinksByUidMutation,
  usePostPaymentLinksByUidSendMutation,
  useGetProfilesByMerchantProfileUidBalanceQuery,
  useGetProfilesQuery,
  useGetPurchasesQuery,
  useGetPurchasesByUidQuery,
  usePostReportingMutation,
  usePostSearchMutation,
  useGetSettingsQuery,
  useGetSettlementsQuery,
  useGetSettlementsByUidQuery,
  useGetSettlementsByUidSpecificationsQuery,
  useGetSettlementsByUidSpecificationsAndSpecificationUidQuery,
  useGetSettlementsByUidSpecificationsAndSpecificationUidRowsQuery,
  useGetStatisticsTotalsQuery,
  useGetStatisticsChartsQuery,
  useGetTicketsQuery,
  usePostTicketsMutation,
  useGetTicketsByUidQuery,
  useGetTopupsByUidQuery,
  usePostTopupsMutation,
  useGetTransactionsQuery,
  usePostTransactionsMutation,
  useGetTransactionsByUidQuery,
  useGetTransactionsByUidLogQuery,
  useGetTransactionsByUidPayoutsQuery,
  useGetTransactionsByTransactionUidRefundsAndRefundUidPayoutsQuery,
  useGetTransactionsByUidRefundableQuery,
  usePostTransactionByUidRefundsMutation,
  useGetTransactionsByUidTrackingQuery,
  useGetTransactionsByUidTrackingAndTrackingUidQuery,
  useDeleteUserMutation,
  useGetUsersWhoamiQuery,
  usePostWithdrawalsMutation,
  useGetWithdrawalByUidQuery,
  useGetWithdrawalsByUidPayoutsQuery,
} = injectedRtkApi;
